<template>
  <div class="provider-proof">
    <div class="provider-proof-form">
      <span class="form-title">服务商完税证明</span>
      <el-form ref="form" label-width="130px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="状态" prop="taxStatus">
              <el-select v-model="form.taxStatus">
                <el-option v-for="(item, index) in taxStatusEnum" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="时间" prop="taxTime">
              <el-date-picker v-model="form.taxTime" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item style="margin-bottom: 0px; text-align: right;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-bottom: 10px;">
      <el-button size="small" type="primary" @click="generateTax()">生成上月完税证明</el-button>
    </div>
    <el-table size="small" :data="data">
      <el-table-column prop="taxMonth" label="时间" width="200">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.taxMonth, '{y}-{m}') }}
        </template>
      </el-table-column>
      <el-table-column prop="totalTaxAmount" label="完税金额" width="250"> </el-table-column>
      <el-table-column label="完税证明" width="300">
        <template slot-scope="scope">
          <el-button v-if="scope.row.fileEntity" type="text" size="small" @click="handleDownload(scope.row.fileEntity)">
            {{ scope.row.fileEntity.fileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="providerName" label="供应商" width="400"> </el-table-column>
      <el-table-column label="最近上传时间" width="300">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.taxUploadTime, '{y}-{m}-{d}') }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="160">
        <template slot-scope="scope">
          {{ getTaxStatus(scope.row.taxStatus) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleUpload(scope.row)">{{ scope.row.taxStatus === 0 ? '上传' : '重新上传' }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :current-page.sync="page.index"
      :page-size="page.size"
      :total="count"
      @current-change="handlePageChange()"
    >
    </el-pagination>

    <add-tracking ref="invoceRef"></add-tracking>

    <el-upload style="visibility: hidden" action="/paywages/api/tax/upload" :show-file-list="false" :http-request="uploadFile" multiple>
      <el-button size="small" type="primary" ref="uploadRef"></el-button>
    </el-upload>
  </div>
</template>

<script>
import api from '@/api/api';
import { parseTime } from '@/utils';
import { taxStatusEnum } from '@/utils/enum';
import AddTracking from './components/addTracking';

export default {
  name: 'providerProof',
  components: {
    AddTracking,
  },
  data() {
    return {
      taxStatusEnum,
      form: {
        taxStatus: -1,
        taxTime: '',
      },
      editTaxId: '',
      data: [],
      count: 0,
      page: {
        index: 1,
        size: 10,
      },
    };
  },
  created() {
    this.getTaxList();
  },
  methods: {
    submitForm() {
      this.page.index = 1;
      this.getTaxList();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.getTaxList();
    },
    handleUpload(tax) {
      this.editTaxId = tax.taxId;
      this.$refs.uploadRef.$el.click();
    },
    handlePageChange() {
      this.getTaxList();
    },

    getTaxList() {
      const params = Object.assign({}, this.form, this.page);
      params.index -= 1;

      if (params.taxTime) params.taxTime = new Date(params.taxTime).getTime();

      api
        .getTaxList({
          params: {
            params,
          },
        })
        .then((res) => {
          this.data = res.data;
          this.count = res.count || 0;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },

    generateTax() {
      api
        .generateTax()
        .then((res) => {
          if (res === 0) {
            this.$message({
              type: 'success',
              message: '已生成上月完税证明',
            });
          }
          // this.data = res.data;
          // this.count = res.count || 0;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    uploadFile(params) {
      const formData = new FormData();
      formData.append('file', params.file);
      formData.append('fileName', params.file.name);
      formData.append('taxId', this.editTaxId);

      api
        .uploadTax({
          params: {
            data: formData,
          },
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '完税证明文件上传成功',
          });
          this.getTaxList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    handleDownload(data) {
      if (!data.fileId) {
        this.$message({
          type: 'error',
          message: '不存在合同文件',
        });
        return;
      }
      const params = {
        fileId: data.fileId,
      };

      api.fileDownload(params);
    },
    getFormatDate(time, format) {
      return time ? parseTime(new Date(time), format) : '';
    },
    getTaxStatus(status) {
      // eslint-disable-next-line arrow-parens
      const findStatus = taxStatusEnum.find((item) => item.value === status);
      return findStatus ? findStatus.label : '';
    },
  },
};
</script>

<style lang="less" scoped>
.provider-proof {
  .provider-proof-tip {
    padding: 8px 12px;
    border: 1px solid #ffcd61;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fffcf2;
    margin-bottom: 24px;
    > span {
      display: block;
    }
  }
  .provider-proof-form {
    border: 1px solid #ebeef5;
    padding: 16px;
    margin-bottom: 16px;
    .form-title {
      font-size: 16px;
      font-weight: 700;
      color: #050505;
      margin-bottom: 20px;
      display: block;
    }
  }
  /deep/ .el-date-editor.el-input {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }
  /deep/ .el-pagination {
    margin-top: 10px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dutyPaid/providerProof.vue